// src/components/NewReservation/ReservationFullScreen.jsx

import React from 'react';
import './css/fullScreen.css';

const ReservationFullScreen = ({ theme, formContent }) => {
  return (
    <>

      <div className="form-section">{formContent}</div>
    </>
  );
};

export default ReservationFullScreen;
